// source: tableau/metrics/models/duration.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return window;
}.call(null));

var tableau_metrics_models_date_granularity_pb = require('../../../tableau/metrics/models/date_granularity_pb.js');
goog.object.extend(proto, tableau_metrics_models_date_granularity_pb);
goog.exportSymbol('proto.tableau.metrics.models.p4.Duration', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.Duration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tableau.metrics.models.p4.Duration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.Duration.displayName = 'proto.tableau.metrics.models.p4.Duration';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.Duration.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.Duration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.Duration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.Duration.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateGranularity: jspb.Message.getFieldWithDefault(msg, 1, 0),
    numberOfUnits: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.Duration}
 */
proto.tableau.metrics.models.p4.Duration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.Duration;
  return proto.tableau.metrics.models.p4.Duration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.Duration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.Duration}
 */
proto.tableau.metrics.models.p4.Duration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.tableau.metrics.models.p4.DateGranularity} */ (reader.readEnum());
      msg.setDateGranularity(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumberOfUnits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.Duration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.Duration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.Duration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.Duration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateGranularity();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNumberOfUnits();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional DateGranularity date_granularity = 1;
 * @return {!proto.tableau.metrics.models.p4.DateGranularity}
 */
proto.tableau.metrics.models.p4.Duration.prototype.getDateGranularity = function() {
  return /** @type {!proto.tableau.metrics.models.p4.DateGranularity} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.tableau.metrics.models.p4.DateGranularity} value
 * @return {!proto.tableau.metrics.models.p4.Duration} returns this
 */
proto.tableau.metrics.models.p4.Duration.prototype.setDateGranularity = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 number_of_units = 2;
 * @return {number}
 */
proto.tableau.metrics.models.p4.Duration.prototype.getNumberOfUnits = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tableau.metrics.models.p4.Duration} returns this
 */
proto.tableau.metrics.models.p4.Duration.prototype.setNumberOfUnits = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.tableau.metrics.models.p4);
